import { environment } from "@/aws-exports";
import { Report, UpdateReportParam } from "@/types/entities";
import axios from "axios";

const ENDPOOINT = environment.API.endpoints[0].endpoint;

function getErrorMessage(err: any) {
  if (!err || !err.response) {
    return "Unexpected Error";
  }
  console.log(`getErrorMessage: ${err.response}`);
  if (err.response.data) {
    const { message } = err.response.data;
    return message ? message : err.response.data;
  } else {
    return "Unexpected Error";
  }
}
// レポート（最上位の概念）の一覧を取得
function getReports() {
  return new Promise( async (resolve, reject) => {
    try {

      const response = await axios.get(`${ENDPOOINT}/readReport`);
      console.log(response);
      if (response.status === 200) {
        resolve(response.data.reports);
      } else {
        console.log(response);
        reject(response.data);
      }
    } catch (err) {
      reject(getErrorMessage(err));
    }
  });
}

// レポート（最上位の概念）の新規作成
function createReport(reportName: string) {
  return new Promise( async (resolve, reject) => {
    try {
      const response = await axios.post(`${ENDPOOINT}/createReport`, {
        reportName,
      });
      console.log(response);
      if (response.status === 200) {
        const { reports } = response.data;
        // TODO: 本当は作れたものだけをシンプルに返すのがよいかも
        // 今は1個作成すると全部の定義がかえってくるので、name & token で該当を抽出
        const target = reports.filter((i: Report) => i.report_name === reportName)[0];
        resolve(target);
      } else {
        console.log(response);
        reject(response.data);
      }
    } catch (err) {
      reject(getErrorMessage(err));
    }
  });
}

// レポート（最上位の概念）の情報更新
function updateReport(report: UpdateReportParam) {
  return new Promise( async (resolve, reject) => {
    try {
      const response = await axios.post(`${ENDPOOINT}/updateReport`, {
        reportId: report.reportId,
        reportName: report.reportName,
        isUpdateToken: report.isUpdateToken,
      });
      console.log(response);
      if (response.status === 200) {
        // TODO: 本当は更新対象だけをシンプルに返すのがよいかな
        const { reports } = response.data;
        resolve(reports);
      } else {
        console.log(response);
        reject(response.data);
      }
    } catch (err) {
      reject(getErrorMessage(err));
    }
  });
}

// レポート（最上位の概念）の削除
function deleteReport(reportId: string) {
  return new Promise( async (resolve, reject) => {
    try {
      const response = await axios.post(`${ENDPOOINT}/deleteReport`, {
        reportId,
      });
      console.log(response);
      if (response.status === 200) {
        // TODO: 本当は更新対象だけをシンプルに返すのがよいかな
        const { reports } = response.data;
        resolve(reports);
      } else {
        console.log(response);
        reject(response.data);
      }
    } catch (err) {
      reject(getErrorMessage(err));
    }
  });
}

// 帳票テンプレートの一覧を取得
// 指定したレポートの一覧
function getTemplates(reportId: string) {
  return new Promise( async (resolve, reject) => {
    try {
      if (!reportId) {
        reject("reportId must be specified");
        return;
      }
      const response = await axios.get(`${ENDPOOINT}/template/${reportId}`);
      console.log(response);
      if (response.status === 200) {
        // なにもない場合も1件で返ってくる(& 中身は空オブジェクト)
        // その回避のための filter
        const filteredTemplates = response.data.filter((t: any) => "id" in t);
        resolve(filteredTemplates);
      } else {
        reject(response.data);
      }
    } catch (err) {
      reject(getErrorMessage(err));
    }
  });
}

// 帳票テンプレートの新規追加（アップロード）
function createTemplate(reportId: string, file: any)  {
  return new Promise( async (resolve, reject) => {
    try {
      if (!file) {
        reject("Arguments is invalid");
        return;
      }
      // TODO: 今は1件のみ
      const formData = new FormData();
      formData.append("name", file.name);
      formData.append("group", file.group);
      formData.append("file", file.file);
      const response = await axios.post(`${ENDPOOINT}/template/${reportId}`, formData);
      console.log(response);
      if (response.status === 201) {
        resolve(response.data);
      } else {
        reject(response.data);
      }
    } catch (err) {
      reject(getErrorMessage(err));
    }
  });
}

// 帳票テンプレートの情報更新（アップロード）
function updateTemplate(reportId: string, templateId: string, file: any)  {
  return new Promise( async (resolve, reject) => {
    try {
      if (!file) {
        reject("Arguments is invalid");
        return;
      }
      const formData = new FormData();
      ["name", "group", "file"].forEach((key) => {
        if (key in file) {
          formData.append(key, file[key]);
        }
      });
      const response = await axios.put(`${ENDPOOINT}/template/${reportId}/${templateId}`, formData);
      console.log(response);
      if (response.status === 200) {
        resolve(response.data);
      } else {
        reject(response.data);
      }
    } catch (err) {
      reject(getErrorMessage(err));
    }
  });
}

// 帳票テンプレートの削除
function deleteTemplates(reportId: string, templateIds: any[]) {
  return new Promise( async (resolve, reject) => {
    try {
      if (!reportId) {
        reject("reportId must be specified");
        return;
      }
      const response = await axios.delete(`${ENDPOOINT}/template/${reportId}/${templateIds[0]}`);
      console.log(`c:d:t:s: ${response}`);
      if (response.status === 204) {
        resolve(response);
      } else {
        reject(response);
      }
    } catch (err) {
      console.log(`c:d:t:e: ${err}`);
      reject(getErrorMessage(err));
    }
  });
}

const Report = {
  getReports,
  createReport,
  updateReport,
  deleteReport,

  getTemplates,
  createTemplate,
  updateTemplate,
  deleteTemplates,
};

export default Report;
